<ng-container *transloco="let t; prefix:'manage-smart-filters'">

  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{t('edit-smart-filter', {name: smartFilter().name | sentenceCase})}}
    </h4>

    <button type="button" class="btn-close" [attr.aria-label]="t('close')" (click)="close()"></button>
  </div>

  <div class="m-3 modal-body">
    <label for="smart-filter-title" class="form-label">{{t('name-label')}}</label>
    <input id="smart-filter-title" class="form-control" [formField]="formGroup.name" type="text"
           [appFormField]="formGroup.name" aria-describedby="smart-filter-title-validations">
    <app-validation-errors inputId="smart-filter-title" [control]="formGroup.name" [messages]="{
          duplicateName: t('filter-name-unique')
        }" />
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">{{t('cancel')}}</button>
    <button type="button" class="btn btn-primary" [disabled]="formGroup().invalid()" (click)="save()">{{t('save')}}</button>
  </div>

</ng-container>
